import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="timeline-countdown"
// Displays days and hours countdown to an event date
export default class extends Controller {
  static targets = ["daysValue", "hoursValue"]
  static values = { eventDate: String }

  connect() {
    this.updateCountdown()
    this.interval = setInterval(() => this.updateCountdown(), 60000)
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  updateCountdown() {
    if (!this.eventDateValue) return

    const eventDate = new Date(this.eventDateValue)
    const now = new Date()
    const diff = eventDate - now

    if (diff <= 0) {
      if (this.hasDaysValueTarget) this.daysValueTarget.textContent = "0"
      if (this.hasHoursValueTarget) this.hoursValueTarget.textContent = "00"
      return
    }

    const days = Math.floor(diff / (1000 * 60 * 60 * 24))
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))

    if (this.hasDaysValueTarget) this.daysValueTarget.textContent = days.toString()
    if (this.hasHoursValueTarget) this.hoursValueTarget.textContent = hours.toString().padStart(2, '0')
  }
}
